import { render, staticRenderFns } from "./generaltype.vue?vue&type=template&id=5b313eac"
import script from "./generaltype.vue?vue&type=script&lang=ts"
export * from "./generaltype.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports